import { useBranch, Branch } from 'context/BranchContext';
import { useFetchUserData } from 'queries/auth/user';

export const useBranchContext = () => {
  const { userData } = useFetchUserData();
  const { selectedBranchId, selectedBranch, branches, setSelectedBranchId, isOwner, isBranchAdmin, isLoading } = useBranch();
  
  const effectiveBranches: Branch[] = (branches && branches.length > 0)
    ? branches
    : (userData?.user_branches || (userData?.assigned_branch ? [userData.assigned_branch] : []));

  return {
    branchId: selectedBranchId || userData?.branch_id || userData?.assigned_branch?.id,
    branchName:
      selectedBranch?.name ||
      selectedBranch?.branch_name ||
      userData?.assigned_branch_name ||
      userData?.assigned_branch?.branch_name ||
      userData?.assigned_branch?.name ||
      userData?.branch_name,
    shopId: userData?.shop_id,
    isMainBranch:
      selectedBranch?.is_main ||
      selectedBranch?.is_main_branch ||
      userData?.assigned_branch?.is_main ||
      userData?.assigned_branch?.is_main_branch ||
      userData?.is_main_branch ||
      false,
    businessType: userData?.business_type,
    canManageBranches: isOwner || isBranchAdmin || userData?.is_main_branch || userData?.is_admin || false,
    canApprovePricing: isOwner || isBranchAdmin || userData?.is_main_branch || userData?.is_admin || false,
    canApproveTransfers: isOwner || isBranchAdmin || userData?.is_main_branch || userData?.is_admin || false,
    branches: effectiveBranches,
    switchBranch: setSelectedBranchId,
    selectedBranch: selectedBranch || userData?.assigned_branch || null,
    isLoading,
  };
};
